<template>
  <main>
    <DetailNews />
  </main>
</template>

<script>
const DetailNews = () => import('@/components/News/DetailMain')

export default {
  components: {
    DetailNews
  }
}
</script>
